import * as type from '../types/user_refresh';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestTokenRefresh = actionCreator(type.REQUEST_TOKEN_REFRESH);
export var successTokenRefresh = actionCreator(type.SUCCESS_TOKEN_REFRESH);
export var failureTokenRefresh = actionCreator(type.FAILURE_TOKEN_REFRESH);